var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"online-listen-comp",on:{"click":_vm.handleOnlineListen}},[_vm._t("default",function(){return [_c('el-button',{attrs:{"type":_vm.buttonType,"disabled":_vm.disabled}},[_vm._v(_vm._s(_vm.showText))])]},{"opening":_vm.opening})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }